// extracted by mini-css-extract-plugin
export default {"Delic":"Delic_Delic__EE12j","content":"Delic_content__4cAX0","Omne":"Delic_Omne__p-0Jv"};